import { loadStripe, Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

/**
 * Lazily loads Stripe.js the first time a payment UI actually renders.
 * Never call loadStripe() at module level -- that pulls js.stripe.com onto every
 * public page that merely imports the component (and logs a rejection when the
 * script is blocked, e.g. by ad blockers or bots).
 *
 * The promise is cached so <Elements stripe={getStripe()}> stays referentially
 * stable across renders. A failed load resolves to null (Elements tolerates this)
 * and is retried on the next call instead of surfacing an unhandled rejection.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const key = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
    stripePromise = key
      ? loadStripe(key).catch((err) => {
          console.warn('Stripe.js failed to load', err)
          stripePromise = null
          return null
        })
      : Promise.resolve(null)
  }
  return stripePromise
}
